import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import { ClientRequisitionContactService } from '../../../services';
import { CompanyService } from 'src/app/users/services';

@Component({
  selector: 'app-client-requisition-view-modal',
  templateUrl: './client-requisition-view-modal.component.html',
  styleUrls: ['./client-requisition-view-modal.component.css']
})
export class ClientRequisitionViewModalComponent implements OnInit {
  clientRequisitionContactDetail: any;
  idFromParent: number;
  companyName:any;

  constructor(
    private ClientRequisitionContactService:ClientRequisitionContactService,
    private companyService:CompanyService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig
  ) 
  {
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.showCrcDetails();
  }
  
  showCrcDetails()
  {
    this.ClientRequisitionContactService.getClientRequisitionContactDetail(this.idFromParent).subscribe((data:any) =>{
      this.clientRequisitionContactDetail = data;
      // this.companyService.GetCompanyEditDetails(data.clientCompanyId).subscribe((companydata:any)=>{
      //   this.companyName=companydata.vendorName;
      // });
    },error => {
      console.log(error)
    })
  }
}
